const translations = {
    "en": {
        "nav.home": "HOME",
        "nav.what": "WHAT IS 10KA",
        "nav.avatar": "AVATAR",
        "nav.story": "STORY",
        "nav.world": "THE WORLD",
        "nav.unlock": "UNLOCK",
        "nav.shop": "SHOP",
        "nav.lang.en": "EN",
        "nav.lang.es": "ES",
        
        // Index - Hero
        "index.hero.subtitle": "Sneakers You Can Wear Everywhere",
        
        // Index - Real World
        "index.real.title": "REAL WORLD: SNEAKERS YOU CAN WEAR",
        "index.real.desc": "Physical World Real Craftsmanship. 10KA transforms your shoes into an identity.",
        "index.real.btn": "EXPLORE SNEAKERS",
        
        // Index - Digital World (360)
        "index.digital.title": "DIGITAL WORLD: SNEAKERS FOR YOUR AVATAR",
        "index.digital.desc": "Every sneaker you hold in real life has its digital twin. Bring them into videogames and the metaverse.",
        "index.digital.hint": "Drag to rotate",
        "index.digital.loading": "Loading 360°...",
        "index.digital.btn": "ENTER THE WORLD",
        
        // Index - Collections
        "index.col.title": "SHOP BY COLLECTION",
        "index.col.sneakers": "SNEAKERS",
        "index.col.hoodies": "HOODIES",
        "index.col.caps": "CAPS",
        "index.col.fragrance": "FRAGRANCE",
        "index.col.jewelry": "JEWELRY",
        "index.col.toys": "TOYS",
        
        // Shop Filters
        "shop.filters.title": "FILTERS",
        "shop.filters.categories": "CATEGORIES",
        "shop.filters.all": "All",
        "shop.filters.digital": "DIGITAL TWIN",
        "shop.filters.hasnft": "Includes NFT Wearable",
        
        // General
        "footer.desc": "Limited in the World. Unlimited in the Metaverse.",
        "footer.rights": "© 2026 10KA STORE. ALL RIGHTS RESERVED."
    },
    "es": {
        "nav.home": "INICIO",
        "nav.what": "QUÉ ES 10KA",
        "nav.avatar": "AVATAR",
        "nav.story": "HISTORIA",
        "nav.world": "EL MUNDO",
        "nav.unlock": "DESBLOQUEAR",
        "nav.shop": "TIENDA",
        "nav.lang.en": "EN",
        "nav.lang.es": "ES",
        
        "index.hero.subtitle": "Zapatillas Que Puedes Usar en Cualquier Lugar",
        
        "index.real.title": "MUNDO REAL: ZAPATILLAS PARA USAR",
        "index.real.desc": "Artesanía real del mundo físico. 10KA transforma tus zapatos en una identidad.",
        "index.real.btn": "EXPLORAR ZAPATILLAS",
        
        "index.digital.title": "MUNDO DIGITAL: ZAPATILLAS PARA TU AVATAR",
        "index.digital.desc": "Cada zapatilla física tiene su gemelo digital. Llévalas a los videojuegos y al metaverso.",
        "index.digital.hint": "Arrastra para rotar",
        "index.digital.loading": "Cargando 360°...",
        "index.digital.btn": "ENTRAR AL MUNDO",
        
        "index.col.title": "COMPRAR POR COLECCIÓN",
        "index.col.sneakers": "ZAPATILLAS",
        "index.col.hoodies": "SUDADERAS",
        "index.col.caps": "GORRAS",
        "index.col.fragrance": "FRAGANCIAS",
        "index.col.jewelry": "JOYERÍA",
        "index.col.toys": "JUGUETES",

        // Shop Filters
        "shop.filters.title": "FILTROS",
        "shop.filters.categories": "CATEGORÍAS",
        "shop.filters.all": "Todas",
        "shop.filters.digital": "GEMELO DIGITAL",
        "shop.filters.hasnft": "Incluye NFT Wearable",
        
        "footer.desc": "Limitado en el Mundo. Ilimitado en el Metaverso.",
        "footer.rights": "© 2026 10KA STORE. TODOS LOS DERECHOS RESERVADOS."
    }
};

function initLanguage() {
    let currentLang = localStorage.getItem("10ka_lang") || "en";
    
    function applyLanguage(lang) {
        document.querySelectorAll("[data-i18n]").forEach(el => {
            const key = el.getAttribute("data-i18n");
            if(translations[lang] && translations[lang][key]) {
                el.innerText = translations[lang][key];
            }
        });
        
        // Update language toggles
        const enBtn = document.getElementById("lang-en");
        const esBtn = document.getElementById("lang-es");
        if(enBtn && esBtn) {
            if(lang === "en") {
                enBtn.classList.add("text-white");
                enBtn.classList.remove("text-silver", "hover:text-white");
                esBtn.classList.add("text-silver", "hover:text-white");
                esBtn.classList.remove("text-white");
            } else {
                esBtn.classList.add("text-white");
                esBtn.classList.remove("text-silver", "hover:text-white");
                enBtn.classList.add("text-silver", "hover:text-white");
                enBtn.classList.remove("text-white");
            }
        }
    }

    applyLanguage(currentLang);

    // Expose toggle function
    window.toggleLanguage = function(lang) {
        currentLang = lang;
        localStorage.setItem("10ka_lang", lang);
        applyLanguage(lang);
    }
}

document.addEventListener("DOMContentLoaded", initLanguage);
